import { Column } from 'app/design/primitives/box';
import { Button } from 'app/design/primitives/button';
import { useScopedTranslation } from 'app/hooks/i18n';
import { useNavigation } from 'app/hooks/navigation';
import { askForPayment } from 'app/network/plan';
import type { ActivePlan } from './shared';

export const PlanActions = ({
  activePlan,
  isDragonEventActive,
  onAddCode,
  showAddCodeButton,
}: {
  activePlan: ActivePlan | undefined;
  isDragonEventActive: boolean;
  onAddCode: () => void;
  showAddCodeButton: boolean;
}) => {
  const navigation = useNavigation();
  const { t } = useScopedTranslation();
  const showPaymentButton = Boolean(activePlan && askForPayment(activePlan) && !isDragonEventActive);
  if (!showPaymentButton && !showAddCodeButton) return null;

  return (
    <Column gap="spacing.general.x4" marginTop="spacing.general.x4">
      {showPaymentButton ? (
        <Button onPress={() => navigation.navigate('payment', undefined, { pop: true })} variant="primary">
          {t('subscribeButton')}
        </Button>
      ) : null}
      {showAddCodeButton ? (
        <Button onPress={onAddCode} variant="secondary">
          {t('addCodeButton')}
        </Button>
      ) : null}
    </Column>
  );
};
